import { useState } from "react";
import { timeline } from "@/mocks/chigua";

export default function FloorTimeline() {
  const [following, setFollowing] = useState(false);

  return (
    <section id="line" className="scroll-mt-20 bg-background-100/70 py-10 md:py-14">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium tracking-widest text-primary-600">ONE LIVE THREAD</span>
          <h2 className="mt-1 text-2xl text-foreground-950 md:text-4xl">一条正在连的瓜 · 楼层时间线</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">{timeline.summary}</p>
          <div className="mt-4 flex items-center justify-center gap-2">
            <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              {timeline.story.cat}
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
              <span className="h-2 w-2 animate-pulse rounded-full bg-accent-500" />
              实时更新中
            </span>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-3xl">
          <ol className="relative border-l-2 border-dashed border-primary-200 pl-6 md:ml-6">
            {timeline.floors.map((f) => (
              <li key={f.no} className="relative pb-6">
                <span className="absolute -left-[31px] top-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-background-50 bg-secondary-500 text-background-50">
                  <i className="ri-arrow-up-line text-xs leading-none" />
                </span>
                <article className="rounded-2xl border border-background-200/70 bg-background-50 p-5">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <span className="text-xs font-bold text-primary-700">#{f.no} 楼</span>
                    <span className="text-sm font-medium text-foreground-900">{f.author}</span>
                    <span className="text-xs text-foreground-400">{f.time}</span>
                    {f.tag && (
                      <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">
                        {f.tag}
                      </span>
                    )}
                    <span className="ml-auto inline-flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-thumb-up-line leading-none" />
                      {f.votes.toLocaleString()}
                    </span>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">{f.content}</p>
                </article>
              </li>
            ))}
          </ol>
        </div>

        <div className="mt-4 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <button
            onClick={() => setFollowing((v) => !v)}
            className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full px-6 py-3 text-sm font-medium transition-colors ${
              following
                ? "bg-accent-500 text-background-50 hover:bg-accent-600"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            <i className={`${following ? "ri-notification-3-fill" : "ri-notification-3-line"} text-base leading-none`} />
            {following ? "已蹲上，更新会顶上来" : "蹲上这条瓜"}
          </button>
          <a
            href="#field"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            回到瓜田
            <i className="ri-arrow-right-line text-sm leading-none" />
          </a>
        </div>
      </div>
    </section>
  );
}